import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSpinner } from '@angular/material/progress-spinner';
import { MatSnackBar } from '@angular/material/snack-bar';
import { validationmethod } from '../../../shared/common/validationmethod';
import { LocalStorageSettingsService } from '../../../shared/services/local-storage-settings.service';
import { CommonService } from '../../../shared/services/common.service';
import { ErrorMessages } from '../../../shared/common/errormessages';
import { AsignUserRoleService } from '../../../shared/services/asign-user-role.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { constants } from '../../../shared/common/contants';
import { RestApi } from 'src/app/shared/RestApi/restApi';
import { HttpHeaders, HttpClient } from '@angular/common/http';

interface trnxCommonServiceInfo {
  statusMessage: any;
  error: boolean;
  data: any;
}

export interface checkinListDialogData {
  edata: any;
  page: any;
  columns: any;
  remarksData: any;
  childId: any;
}

@Component({
    selector: 'app-assign-user-role-popup',
    templateUrl: './assign-user-role-popup.component.html',
    styleUrls: ['./assign-user-role-popup.component.scss'],
    standalone: false
})
/*
   @Author:Ravi G
   @Date:28-06-2022
*/
export class AssignUserRolePopupComponent implements OnInit {
  private headers = new HttpHeaders({ "Content-Type": "application/json" });
  FormValid: UntypedFormGroup;
  validation_messages: any;
  backgroundColorButton = '';
  userRoleNameData: any;
  DNSList: any;
  bpCompnayId: any;
  userrolesmstrid: '';
  usersData: any;
  companyData: any;
  assignUserRolePopupData = {
    'assignuserroleid': 0,
    'userid': '',
    'roleid': '',
    'createdBy': '',
    'createdDate': '',
    'lastModifiedBy': '',
    'lastModifiedDate': '',
    'username': '',
    'rolename': '',
    'tenantid': '',
    'companyid':'',
    'dnsname': '',
    'workspaceid': '',
  };
  companyidToretrieveUser;
  userid: '';
  buttonName: any;
  materialData: any;
  isroleassigned: any;
  isCheckboxSelected: boolean = false;
formValidCheckbox: UntypedFormGroup;


  constructor(private http: HttpClient, private restAPI: RestApi, public dialogref: MatDialogRef<AssignUserRolePopupComponent>, private validation: validationmethod, private localStorageSettings: LocalStorageSettingsService,
    private commonService: CommonService, private errorMsg: ErrorMessages, private asignUserRoleService: AsignUserRoleService, private spinner: NgxUiLoaderService, private snackBar: MatSnackBar, @Inject(MAT_DIALOG_DATA) public data: checkinListDialogData, private constants: constants) {
    this.validation_messages = this.errorMsg.concreteUpdateReportMessages;
  }

  ngOnInit() {
    console.log('edata');
    console.log(this.data.edata);
    console.log(this.data.edata.assignuserroleid);
    console.log();

    this.formvalidations();
    this.formValidationsCheckbox();
    if (this.data.edata.assignuserroleid != undefined) {
      console.log(this.data.edata.tenantid)
      console.log(this.assignUserRolePopupData);
      this.assignUserRolePopupData = {
        'assignuserroleid': this.data.edata.assignuserroleid,
        'userid': this.data.edata.userid,
        'roleid': this.data.edata.roleid,
        'createdBy': this.data.edata.createdBy,
        'createdDate': this.data.edata.createdDate,
        'lastModifiedBy': this.data.edata.lastModifiedBy,
        'lastModifiedDate': this.data.edata.lastModifiedDate,
        'username': this.data.edata.username,
        'rolename': this.data.edata.rolename,
        'tenantid': this.data.edata.tenantid,
        'companyid': this.data.edata.companyid,
        'dnsname': this.data.edata.dnsname,
        'workspaceid': this.data.edata.workspaceid,
      };
      this.assignUserRolePopupData.tenantid = this.data.edata.workspaceid;
      this.assignUserRolePopupData.roleid = this.data.edata.roleid;
      console.log(this.assignUserRolePopupData);
      this.FormValid.get('userid').disable();
      this.FormValid.get('tenantid').disable();
      this.FormValid.get('companyid').disable();

      this.buttonName = 'Update';
    } else {
      this.buttonName = 'Save';
    }
    console.log(this.materialData);
    this.backgroundColorButton = this.localStorageSettings.getSettings('ColorA');
    if (this.buttonName == "Update") {
      console.log(this.buttonName+"==============================================")
      this.Dropdown();
      this.DropdownDNS(this.assignUserRolePopupData.companyid);

    } else {
      this.Dropdown();
    }
   
    
  }

  formvalidations() {
    this.FormValid = new UntypedFormGroup({
      'userrolesmstrid': new UntypedFormControl('', [Validators.required]),
      'userid': new UntypedFormControl('', [Validators.required]),
      'tenantid': new UntypedFormControl('', [Validators.required]),
      'companyid': new UntypedFormControl('', [Validators.required])
    });
  }

  async Dropdown() {
    var tenantId = this.localStorageSettings.getSettings('dnsName');
    //reteriveing users by dnsId
    this.spinner.start()
  
    console.log('userRoleNameData');
    console.log(this.userRoleNameData);

    //retrieve Users For Assign User Role
    // this.asignUserRoleService.retrieveUsers().subscribe(response => {
    //   console.log(response);

    //   if (response.error == true) {

    //     this.spinner.stop();

    //     this.snackBar.open(response.statusMessage, 'OK', { duration: 5000 });


    //   } else {

    //     this.spinner.stop();

    //     this.usersData = response;

    //   }
    // });
   

    let response = await this.http.get<trnxCommonServiceInfo>(this.restAPI.GET_TRNX_TABLE_DATA_FOR_DROPDOWNS + "/" + "company" + "/" + "compname", { headers: this.headers }).toPromise();
    console.log(response)
    if (response.error == true) {

      this.spinner.stop();

      this.snackBar.open(response.statusMessage, "OK", { duration: 5000 });

    }
    else {

      this.spinner.stop();

      this.companyData = response;
      
      

    }

  }
  //updating and inserting data for assign user role
  async updateData() {
    this.FormValid.markAllAsTouched();
    var tenantId = localStorage.getItem('dnsName');
    if (!this.FormValid.valid) {
      this.snackBar.open("All mandatory fields to be filled.", 'OK', { duration: 5000 });
    }
    else {
      this.spinner.start();
      this.asignUserRoleService.isUserRoleavailableForUser(this.assignUserRolePopupData.userid,this.assignUserRolePopupData.tenantid).subscribe(response => {
        if (response.error == true) {
          console.log('inside isUserRoleavailableForUser');
          console.log(response);
          this.spinner.stop();

          this.snackBar.open(response.statusMessage, 'OK', { duration: 5000 });

        } else {
          this.spinner.stop();
          console.log('inside isUserRoleavailableForUser');
          console.log(response);
          this.isroleassigned = response;
          if (!this.FormValid.valid) {
            this.validation.validateAllFormFields(this.FormValid);
            this.validation.getvalidationmessage();
            return;
          } else if (this.assignUserRolePopupData.assignuserroleid == 0) {
            if (this.isroleassigned > 0) {
              this.snackBar.open(this.constants.isroleassigned, 'OK', { duration: 5000 });
            }
            else {
              this.insertAssignUserRole();
            }
          } else {
            this.insertAssignUserRole();
          }
        }
      });
    }
    console.log('inside');

  }


  insertAssignUserRole() {
    this.asignUserRoleService.insertAssignUserRole(this.assignUserRolePopupData).subscribe(response => {
      if (response.error == true) {
        console.log('inside error');
        console.log(response);
        this.spinner.stop();

        this.snackBar.open(response.statusMessage, 'OK', { duration: 5000 });

      } 
      // else {

      //   this.spinner.stop();
      //   this.dialogref.close();
      //   this.snackBar.open(response.statusMessage, 'OK', { duration: 50000 });
      // }
      else {

        this.spinner.stop();

        if (this.isCheckboxSelected) {

          this.assignUserRolePopupData = {
            assignuserroleid: 0,
            userid: '',
            roleid: '',
            createdBy: '',
            createdDate: '',
            lastModifiedBy: '',
            lastModifiedDate: '',
            username: '',
            rolename: '',
            tenantid: '',
            companyid: '',
            dnsname: '',
            workspaceid: ''
          };

          this.FormValid.reset();

          this.formValidCheckbox.reset();
this.isCheckboxSelected = false;

          this.usersData = [];
          this.userRoleNameData = [];
          this.DNSList = [];

          this.snackBar.open(
            'Assign User Role created successfully',
            'OK',
            { duration: 5000 }
          );

        } else {

          this.dialogref.close();

          this.snackBar.open(
            response.statusMessage,
            'OK',
            { duration: 5000 }
          );
        }
      }
    });
  }

  close() {
    this.dialogref.close();
  }


  async retrieveTrnxDropdownService(tableName, recordsStart, dropDownValuesDisplay) {

    this.spinner.start();

    /**
     * @modified By Vijay Badha
     * @Date 05-04-2024
     * changed the api from GET_TRNXTABLE_DATA_URL  to GET_TRNX_TABLE_DATA_FOR_DROPDOWNS for
     * retrieving the tables data for drop down
     */
    let response = await this.http.get<trnxCommonServiceInfo>(this.restAPI.GET_TRNX_TABLE_DATA_FOR_DROPDOWNS + "/" + tableName + "/" + dropDownValuesDisplay, { headers: this.headers }).toPromise();

    if (response.error == true) {

      this.spinner.stop();

      this.snackBar.open(response.statusMessage, "OK", { duration: 5000 });

      return null;

    }
    else {

      this.spinner.stop();

      return response;

    }

  }

  async DropdownDNS(e) {
    console.log(e)
  //  console.log(e.value)

    console.log(this.assignUserRolePopupData)
    var tenantId = this.localStorageSettings.getSettings('dnsName');
    //reteriveing users by dnsId
    this.spinner.start()
    this.commonService.retrieveDnsService(e).subscribe(response => {

      console.log(response)

      if (response.error == true) {

        this.spinner.stop();

        this.snackBar.open(response.statusMessage, "OK", { duration: 5000 });

        return null;

      }
      else {

        this.spinner.stop();

        this.DNSList = response;
        if (this.buttonName == "Update") {
          // this.retriveUser(this.assignUserRolePopupData.tenantid);
          this.retriveUser(this.assignUserRolePopupData.workspaceid);
        }
        // this.assignUserRolePopupData.tenantid = '';
        // this.assignUserRolePopupData.userid = '';
        // this.assignUserRolePopupData.roleid = '';

       

      }

    });

    console.log('userRoleNameData');
    console.log(this.userRoleNameData);


  }

  async retriveUser(dnsId) {
    console.log(dnsId);
    // if (this.buttonName = 'update') {
    //   dnsId = this.assignUserRolePopupData.tenantid;
    // }
    //retrieve Users For Assign User Role
    this.commonService.retrieveDnsUser(dnsId).subscribe(response => {
      console.log(response);

      if (response.error == true) {

        this.spinner.stop();

        this.snackBar.open(response.statusMessage, 'OK', { duration: 5000 });


      } else {

        this.spinner.stop();

        this.usersData = response;
        // if (this.buttonName == "Update") {
        //   this.retrieveUserroles(this.assignUserRolePopupData.tenantid)
        // }

      }
    });

    this.asignUserRoleService.reteriveUserRoleMstrByDnsId(dnsId).subscribe(response => {

      console.log(response)

      if (response.error == true) {

        this.spinner.stop();

        this.snackBar.open(response.statusMessage, "OK", { duration: 5000 });

        return null;

      }
      else {

        this.spinner.stop();

        this.userRoleNameData = response;

      }

    });

   
  }
  // retrieveUserroles(tenantId) {
  //   this.asignUserRoleService.reteriveUserRoleMstrByDnsId(tenantId).subscribe(response => {

  //     console.log(response)

  //     if (response.error == true) {

  //       this.spinner.stop();

  //       this.snackBar.open(response.statusMessage, "OK", { duration: 5000 });

  //       return null;

  //     }
  //     else {

  //       this.spinner.stop();

  //       this.userRoleNameData = response;

  //     }

  //   });

  // }
formValidationsCheckbox() {
  this.formValidCheckbox = new UntypedFormGroup({
    isCheckboxSelected: new UntypedFormControl(false)
  });
}

}
